import React from 'react';
import { Form } from 'react-bootstrap';
import { Selectize, Fieldset } from '~/components/FormControl';
import PropTypes from 'prop-types';
import { API_PREFIX } from '~/pages/CardSaga/PowerCard/powerCard.api';
import CardMaker from '~/components/CardMaker';
import CardBack from '~/components/CardMaker/components/CardBack';
import { useFormTab } from '~/pages/CardSaga/components/providers/FormTabProvider';
import { renderCardFrontEdit } from '~/components/CardMaker/components/CardFrontEdit/render-card-front';

function CardInformation({ values }) {
    const { cardMetaData, backSides, resetCount } = useFormTab();
    const { keywords } = cardMetaData;
    const { name } = values;

    return (
        <>
            <Fieldset sm={12}>
                <Fieldset.Legend>Card Maker</Fieldset.Legend>
                <CardMaker
                    values={values}
                    apiPrefix={API_PREFIX}
                    displayName={false}
                    cardBackElement={
                        <CardBack
                            pictureName={backSides[0]}
                            pictureVal={backSides[0].split('.').reduce((a, b) => a[b], values)}
                            resetCount={resetCount}
                            id={backSides[0]}
                        />
                    }
                    renderCardFrontEdit={renderCardFrontEdit({ name, hasTitle: false })}
                    iconOrCrop={'icon'}
                />
            </Fieldset>

            <Form.Row>
                <Selectize
                    sm="3"
                    name="keywords"
                    options={keywords ?? []}
                    note="* only published keywords are available for selection."
                />
            </Form.Row>
        </>
    );
}

CardInformation.propTypes = {
    values: PropTypes.object.isRequired,
};
export default CardInformation;
